import { OverlayColorToken } from "./size-selector-overlay-schema";

export type ResolvedOverlayStyling = {
  background: string;
  typography: string;
  ctaBackground: string;
  ctaText: string;
};

/** Base styling used when no per-field Storyblok color tokens are set. */
const defaultStyling: ResolvedOverlayStyling = {
  background: "bg-white",
  typography: "text-neutral-900",
  ctaBackground: "bg-neutral-900 hover:bg-neutral-800",
  ctaText: "text-white",
};

const surfaceBackgroundByToken: Record<OverlayColorToken, string> = {
  white: "bg-white",
  black: "bg-neutral-900",
  beige: "bg-beige-100",
  grey: "bg-neutral-100",
  red: "bg-red-600",
};

const textByToken: Record<OverlayColorToken, string> = {
  white: "text-white",
  black: "text-neutral-900",
  beige: "text-beige-700",
  grey: "text-neutral-600",
  red: "text-red-700",
};

const ctaBackgroundByToken: Record<OverlayColorToken, string> = {
  white: "bg-white hover:bg-neutral-100 border border-neutral-300",
  black: "bg-neutral-900 hover:bg-neutral-800",
  beige: "bg-beige-300 hover:bg-beige-400",
  grey: "bg-neutral-200 hover:bg-neutral-300",
  red: "bg-red-600 hover:bg-red-700",
};

export type OverlayStylingTokens = {
  background?: OverlayColorToken;
  typography?: OverlayColorToken;
  ctaBackground?: OverlayColorToken;
  ctaText?: OverlayColorToken;
};

/**
 * Resolves the final classes from the default styling, with optional per-field
 * Storyblok color tokens taking precedence.
 */
export const resolveOverlayStyling = (
  tokens: OverlayStylingTokens,
): ResolvedOverlayStyling => ({
  background: tokens.background
    ? surfaceBackgroundByToken[tokens.background]
    : defaultStyling.background,
  typography: tokens.typography
    ? textByToken[tokens.typography]
    : defaultStyling.typography,
  ctaBackground: tokens.ctaBackground
    ? ctaBackgroundByToken[tokens.ctaBackground]
    : defaultStyling.ctaBackground,
  ctaText: tokens.ctaText
    ? textByToken[tokens.ctaText]
    : defaultStyling.ctaText,
});
